import styled from 'styled-components';

export const ListItem = styled.li`
  align-items: center;
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  list-style: none;
`;

export const ButtonPlaceholderShape = styled.span`
  border-width: 1px;
  border-radius: 2.5rem;
  height: 4.3rem;
  width: 12.8rem;
`;
